import React from "react";

export default function UploadFailureIcon(props) {
  return <i class="fa fa-close"></i>;
}
